import clsx from 'clsx';
import {
  BuyerCard,
  getCardBrandIcon,
} from 'src/components/Selectors/BuyerSelector/BuyerCard';
import { Content, useContent } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { useGetBuyerPaymentMethods } from 'src/hooks/api/useGetBuyerPaymentMethods';
import { SectionContent } from 'src/modals/common/Detail/Detail.styled';
import { DetailSection } from 'src/modals/common/DetailSection';
import { useRetailSaleContext } from 'src/modals/RetailSale/RetailSaleLocalContext';
import { ContentId } from 'src/utils/constants/contentId';

import { RetailSaleEarningsSection } from './RetailSaleCheckoutStep.components';
import * as styles from './RetailSaleCheckoutStep.css';

export const RetailSaleCheckoutStep = () => {
  const {
    selectedBuyer,
    disabled,
    selectedStoredPaymentMethodId,
    setSelectedStoredPaymentMethodId,
  } = useRetailSaleContext();
  const customerInfoMsg = useContent(ContentId.CustomerInfo);
  const paymentMethodMsg = useContent(ContentId.PaymentMethod);
  const addNewCardMsg = useContent(ContentId.AddNewCard);

  const { data: savedPaymentMethods = [] } = useGetBuyerPaymentMethods(
    selectedBuyer?.buyerEmail
  );

  return (
    <Stack direction="column" gap="l">
      {/* Customer Info Card */}
      {selectedBuyer && (
        <DetailSection name={customerInfoMsg}>
          <SectionContent numOfColumns={1}>
            <BuyerCard buyer={selectedBuyer} />
          </SectionContent>
        </DetailSection>
      )}

      {/* EARNINGS section */}
      <RetailSaleEarningsSection disabled={disabled} />

      {/* PAYMENT METHOD section */}
      <DetailSection name={paymentMethodMsg}>
        <div className={styles.savedCardsSection}>
          {savedPaymentMethods.map((card) => {
            const cardId = card.storedPaymentMethodId;
            const isSelected = selectedStoredPaymentMethodId === cardId;
            return (
              <div
                key={cardId}
                role="radio"
                aria-checked={isSelected}
                tabIndex={0}
                className={clsx(styles.savedCardRow, {
                  [styles.savedCardRowSelected]: isSelected,
                })}
                onClick={
                  disabled
                    ? undefined
                    : () => setSelectedStoredPaymentMethodId(cardId)
                }
                onKeyDown={
                  disabled
                    ? undefined
                    : (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          setSelectedStoredPaymentMethodId(cardId);
                        }
                      }
                }
              >
                <input
                  type="radio"
                  readOnly
                  checked={isSelected}
                  aria-hidden="true"
                />
                <div className={styles.savedCardInfo}>
                  <span className={styles.savedCardNumber}>
                    {getCardBrandIcon(card.cardBrand)} **** {card.cardSummary}
                  </span>
                  {card.expiryMonth != null && card.expiryYear != null && (
                    <span className={styles.savedCardExpiry}>
                      <Content id={ContentId.Expires} /> {card.expiryMonth}/
                      {card.expiryYear}
                    </span>
                  )}
                </div>
                {card.isDefault && (
                  <span className={styles.savedCardBadge}>
                    <Content id={ContentId.Default} />
                  </span>
                )}
              </div>
            );
          })}

          {/* Add a new card option */}
          <button
            type="button"
            onClick={() => {
              setSelectedStoredPaymentMethodId(null);
            }}
            className={clsx(styles.addNewCardRow, {
              [styles.addNewCardRowSelected]:
                selectedStoredPaymentMethodId === null,
            })}
          >
            <input
              type="radio"
              readOnly
              checked={selectedStoredPaymentMethodId === null}
              aria-hidden="true"
            />
            {addNewCardMsg}
          </button>
        </div>
      </DetailSection>
    </Stack>
  );
};
